import { render, staticRenderFns } from "./STableClientWorksComp.vue?vue&type=template&id=16b1ccf1&"
import script from "./STableClientWorksComp.vue?vue&type=script&lang=js&"
export * from "./STableClientWorksComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
